import { render, staticRenderFns } from "./AddCPTeamMember.vue?vue&type=template&id=547c95f2"
import script from "./AddCPTeamMember.vue?vue&type=script&lang=js"
export * from "./AddCPTeamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports